import React, { useEffect } from 'react';
import { Modal, Form, DatePicker, Button } from 'antd';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { fetchWeeklyPlans, forwardWeeklyPlansAsync } from '../redux/slice';
const { RangePicker } = DatePicker;
const WeeklyDatePickerModal = ({
  visible,
  onClose,
  planId,
  startDate,
  endDate,
  page = 1,
  perPage = 10,
  initialWeekMonday = null
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedRange, setSelectedRange] = React.useState([]);
  const [selectedWeekMonday, setSelectedWeekMonday] = React.useState(null);

  const disabledDate = (current) => {
    if (!current) return false;

    const today = moment();
    const startOfCurrentWeek = today.startOf('isoWeek'); // Monday

    const day = current.day(); // 0 = Sun, 6 = Sat
    const isWeekend = day === 0 || day === 6;

    // Disable past weeks + weekends
    return current.isBefore(startOfCurrentWeek, 'day') || isWeekend;
  };
  const getWeekRangeFromMonday = (monday) => {
    const start = monday.clone();
    const end = monday.clone().add(4, 'days'); // Friday
    return { start, end };
  };

  useEffect(() => {
    if (visible) {
      const monday = initialWeekMonday
        ? moment(initialWeekMonday).clone().startOf('isoWeek')
        : moment().startOf('isoWeek');
      setSelectedWeekMonday(monday);
    }
  }, [visible, initialWeekMonday]);

  const handleForward = (values) => {
    const { start, end } = getWeekRangeFromMonday(selectedWeekMonday);
    const payload = {
      id: planId,
      start_date: start.format('YYYY-MM-DD'),
      end_date: end.format('YYYY-MM-DD')
    };

    dispatch(forwardWeeklyPlansAsync(payload)).then((res) => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        // 🔁 Refresh weekly list
        dispatch(
          fetchWeeklyPlans({
            start_date: startDate,
            end_date: endDate,
            page,
            per_page: perPage
          }),
          dispatch(
            fetchWeeklyPlans({
              status: 'ACTIVE'
            })
          )
        );

        form.resetFields();
        onClose();
      }
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      visible={visible}
      onCancel={handleCancel}
      footer={null}
      centered
      destroyOnClose
      width={400}
    >
      <Form form={form} layout="vertical" onFinish={handleForward}>
        <h3 className="font-bold mb-4">Select Week</h3>

        <Form.Item label="Select the week range" style={{ color: '#595959' }}>
          <DatePicker
            picker="week"
            allowClear={false}
            value={selectedWeekMonday}
            disabledDate={disabledDate}
            style={{ width: '100%' }}
            onChange={(date) => {
              if (!date) return;
              setSelectedWeekMonday(moment(date).startOf('isoWeek'));
            }}
            format={(value) => {
              const monday = value.clone().startOf('isoWeek');
              const friday = monday.clone().add(4, 'days');
              return `${monday.format('DD MMM')} - ${friday.format('DD MMM')}`;
            }}
          />
        </Form.Item>

        <div className="flex justify-center gap-3 mt-4">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            Postpone
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default WeeklyDatePickerModal;
